import React from "react";

function IEPmask() {
  return (
    <svg className="svg-mask" width="50px" height="680px" viewBox="0 0 50 680">
      <g>
        <polygon points="2.18847163e-12 -9.23705556e-14 6 -9.23705556e-14 50 680 1.95515132e-12 680"></polygon>
      </g>
    </svg>
  );
}

export default IEPmask;
